<template>
    <div class="commission-setting">
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">Inital Proposal Setting</h2>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
					<el-tabs v-model="current_tab" @tab-click="handleTabClick">
						<el-tab-pane label="Fees & Charges" name="fees_charges">
							<FeesAndChargesTable />
						</el-tab-pane>
					</el-tabs>
        </b-container>
    </div>
</template>
<script>
import { Tabs, TabPane, Button } from 'element-ui'
import FeesAndChargesTable from '@/views/Configurations/InitialProposalSettings/FeesAndChargesSetting/FeesAndChargesTable'

export default {
    components: {
			FeesAndChargesTable,
			[Button.name]: Button,
			[Tabs.name]: Tabs,
			[TabPane.name]: TabPane
    },
    data() {
        return {
					current_tab: 'fees_charges'
        }
    },
		methods:{
			handleTabClick(obj, e){
				this.current_tab = obj.name
			},
		}
}
</script>